import { useMemo } from 'react';

import { convertSecondsToIso8601 } from '@/Module/Lesson/Helper';
import { selectedLessonSectionSelector } from '@/Module/Lesson/Store/Selector/selectedLessonSectionSelector';
import { useAppSelector } from '@/Module/Store/Hook';

interface SchemaObjectType {
  '@context': string;
  '@type': string;
  provider: string;
  width: number;
  height: number;
  name?: string;
  description?: string;
  thumbnailUrl?: string;
  uploadDate?: string;
  duration?: string;
  contentUrl?: string;
}

export const usePrepareVideoSchemaObject = () => {
  const lessonSection = useAppSelector(selectedLessonSectionSelector);

  return useMemo(() => {
    const initialData: SchemaObjectType = {
      '@context': 'https://schema.org',
      '@type': 'VideoObject',
      provider: 'Ino',
      width: 1280,
      height: 720,
    };

    if (lessonSection?.seoTitle) initialData.name = lessonSection.seoTitle;
    if (lessonSection?.seoDescription) initialData.description = lessonSection.seoDescription;
    if (lessonSection?.pictureUrl) initialData.thumbnailUrl = lessonSection.pictureUrl;
    if (lessonSection?.createdDate) initialData.uploadDate = lessonSection.createdDate;
    if (lessonSection?.duration) initialData.duration = convertSecondsToIso8601(lessonSection.duration);
    if (lessonSection?.videoId) initialData.contentUrl = lessonSection?.videoId;

    return initialData;
  }, [lessonSection]);
};
